module.exports = __webpack_public_path__ + "static/Apercu-MediumItalic-d20084cc83dfe9e505584e444907b92e.woff";